import React, { useContext } from "react";
import { RegisterContainer, StepHeader, RegisterLogo } from "../components/Register.styled";
import WizardForm from "../../../components/form/wizard";
import PersonalInformation from "./steps/PersonalInformation";
import PersonalAddress from "./steps/PersonalAddress";
import OTPVerification from "./steps/OTPVerification";
// import SocialService from "./steps/SocialService";
import UploadImage from "./steps/UploadImage";
import IDCard from "./steps/IDCard";
import { NewCitizenContext } from "./NewCitizenContext";
import CodeLogout from "../CodeForm/CodeLogout";
import FarmProfile from "./steps/FarmProfile";
import HouseholdInformation from "./steps/HouseholdInformation";
import { SKIP_OTP } from "../../../config";

const NewCitizensComponent = () => {
  const { checkUserExist, sendOTPMobile, verifyOTP, registerCitizenDetails } = useContext(NewCitizenContext);

  const steps = [
    {
      title: "Personal Information",
      component: PersonalInformation,
      hideBackBtn: true,
      asyncValidator: checkUserExist,
    },
    {
      title: "Household Information",
      component: HouseholdInformation,
    },
    {
      title: "Address",
      component: PersonalAddress,
    },
  ];

  if (SKIP_OTP) {
    steps.push({
      title: "Farm Profile",
      component: FarmProfile,
    });
  } else {
    steps.push(
      {
        title: "Farm Profile",
        component: FarmProfile,
        asyncFn: sendOTPMobile,
      },
      {
        title: "Verification",
        centerTitle: true,
        component: OTPVerification,
        btnNextOverwriteTitle: "Ipadala",
        asyncValidator: verifyOTP,
      }
    );
  }

  steps.push(
    {
      title: "Upload Image",
      centerTitle: true,
      component: UploadImage,
      btnNextOverwriteTitle: "Ipadala",
      asyncValidator: registerCitizenDetails,
    },
    {
      title: "Success",
      centerTitle: true,
      component: IDCard,
      hideBackBtn: true,
      hideWizardSteps: true,
      hideNextBtn: true,
      hideBottom: true,
    },
  );

  return (
    <RegisterContainer>
      <CodeLogout />
      <StepHeader>
        <RegisterLogo src="static/images/logo-banner.png" alt="farmer logo" />
      </StepHeader>
      <WizardForm steps={steps} />
    </RegisterContainer>
  );
};

export default NewCitizensComponent;
